// src/components/Memo.jsx
// Pezzo di JSX ridisegnato solo quando cambia una delle sue dipendenze (come
// useMemo, ma usabile dentro un elenco). Nelle pagine di setup ogni scheda
// dispositivo si ridisegna solo se cambiano i suoi dati, non a ogni
// aggiornamento degli altri dispositivi.
//   <Memo key={id} deps={[a, b]} render={() => (...)} />
import React from 'react';

const same = (a, b) => a.deps.length === b.deps.length && a.deps.every((d, i) => Object.is(d, b.deps[i]));

const Memo = React.memo(function Memo({ render }) { return render(); }, same);

export default Memo;
